import styled from "@emotion/styled";
import React, { useEffect, useRef, useState } from "react";

import { useTicketPackageList } from "@src/hooks/deungi/useTicketPackageList";
import { TicketPackageListResponseDto } from "@src/hooks/deungi/dto/PackageList.dto";

import building_register_ticket_ico from "@src/assets/buildingRegister/building_register_ticket_ico.png";

import building_register_ticket_ten_ico from "@src/assets/buildingRegister/building_register_ticket_ten_ico.png";

import { transferToNative } from "@src/lib/WebAppBridge";

import { css } from "@emotion/react";
import { checkDevice } from "@src/components/deungi/common/utils";
import { PRODUCT_SALE_TYPE, TICKET_TYPE_STRING } from "@src/components/deungi/common/enum";

import PackageCard from "@src/components/deungi/DeungiPackageCard";

import BuildingRegisterPaymentInfoBox from "@src/components/buildingRegister/BuildingRegisterPaymentInfoBox";
import BuildingRegisterTicketBox from "@src/components/buildingRegister/BuildingRegisterTicketBox";
const BuildingRegisterPackageListBox = () => {
    const deviceType = checkDevice();

    const [packageList, setPackageList] = useState({} as TicketPackageListResponseDto[]);
    const [openCheckSubs, setOpenCheckSubs] = useState<boolean>(false);
    const [openCheckDeungiPurchase, setOpenCheckDeungiPurchase] = useState<number>(0);

    const getPackageList = async () => {
        const saleType = deviceType === "ios" ? PRODUCT_SALE_TYPE.IOS : PRODUCT_SALE_TYPE.AOS;
        const res = await useTicketPackageList(saleType);
        setPackageList(res.data.list);
    };

    const onPackageClickHandler = (data: TicketPackageListResponseDto) => {
        if (!data) return;
        if (data?.type === "building_register_ticket") {
            if (deviceType !== "android") {
                const ticketType = ["", ...Object.values(TICKET_TYPE_STRING)];
                const params = JSON.stringify({
                    productCode: data.code,
                    productType: data.type,
                    ticketType: ticketType.indexOf(data.type),
                });
                transferToNative(params, "payTicketInApp");
            } else {
                const params = JSON.stringify({
                    pgType: "kcp.IP29N",
                    product_name: data.name,
                    product_code: data.code,
                    discounted_price: data.discountPrice,
                    type: "building_register_ticket",
                    searchText: "",
                });
                transferToNative(params, "payDeungiTicket");
            }
        }
    };

    useEffect(() => {
        getPackageList();
    }, []);

    return (
        <>
            <Container>
                <BuildingRegisterTicketBox />
                <PackageListBox>
                    <PackageCard
                        title="실시간 건축물대장 열람권"
                        packages={
                            packageList.length > 0
                                ? packageList.filter((el) => el.type === TICKET_TYPE_STRING.BUILDING_REGISTER_TICKET)
                                : []
                        }
                        singleTicketImage={building_register_ticket_ico}
                        multipleTicketsImage={building_register_ticket_ten_ico}
                        active={true}
                        onTitleClick={() => {}}
                        onPackageClick={onPackageClickHandler}
                        onScroll={() => {}}
                    />
                    <BuildingRegisterPaymentInfoBox />
                </PackageListBox>
            </Container>
        </>
    );
};

const PackageListBox = styled.div`
    height: fit-content;

    .packageBox {
        padding: 24px 14px 14px;

        &.active {
            background: #f6faff;
        }
        .titleBox {
            display: flex;
            align-items: center;
            margin-bottom: 14px;

            & > h3 {
                font-size: 18px;
                font-weight: 700;
            }
            & > img {
                width: 20px;
                height: 20px;
                margin-left: 8px;
            }
        }
        .items {
            display: flex;
            align-items: center;
            width: 100%;
            background: #fff;
            border: 1px solid #c9c9c9;
            border-radius: 14px;
            font-size: 16px;
            box-sizing: border-box;
            padding: 14px;
            margin-bottom: 14px;

            :active {
                border: 1px solid #2275ee;
                box-shadow: inset 0 0 0 1px #2275ee;
            }
            .radioItem {
                margin-right: 10px;

                &.hidden {
                    display: none;
                }
            }

            .imageBox {
                position: relative;
                margin: 0;

                min-width: 50px;
                height: 50px;

                border-radius: 8px;
                background-color: #f6faff;

                display: flex;
                align-items: center;
                justify-content: center;

                & > img {
                    width: 38px;
                    height: 38px;

                    &.multiple {
                        width: 50px;
                        height: 50px;
                    }
                }
            }
            & > div {
                display: flex;
                flex-direction: column;
                margin-left: 8px;

                & > span {
                    word-break: keep-all;
                    line-height: 1.1;
                }
                & > small {
                    margin-top: 7px;
                    color: #ff0000;
                }
            }
            & > .price {
                width: fit-content;
                min-width: 95px;
                height: 40px;
                background: #fff;
                border-radius: 8px;
                margin-left: auto;
                text-align: center;
                line-height: 40px;
                word-break: keep-all;
            }
        }
    }
`;

const Container = styled.div`
    height: 100%;
    overflow: scroll;
    background-color: white;
    .backDiv {
        width: 0;
        height: 75px;
    }
`;

const contentStyle = css`
    color: #0c002c;
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
`;

export default BuildingRegisterPackageListBox;
